<template>
    <div class="card">
        <div class="card">
            <TabMenu :model="itemsFiltered"/>
            <router-view/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Service from "../../service/Service";
import axios from "axios";

export default {
    name: "Report",
    components: {},
    async mounted() {
        const service = new Service()
        const dateRanges = await service.gerReportDates()
        const {data} = await axios.get(`report/all-ratings`)

        // const dateRanges = await service.gerReportDates()

        this.setReportRanges(dateRanges)
        this.setReportRatings(data)
        // this.setReportRatings([{
        //         id: "1",
        //         hebrewName: "מתפללת בחיות מתוך הסידור",
        //         options: 'צריכה לשפר, השתדלתי, הצלחתי',
        //         starsCount: 3
        //     },
        //     {
        //         id: "2",
        //         hebrewName: "מתנהגת בדרך ארץ למורה",
        //         options: 'עצוב, צריכה לשפר, השתדלתי, הצלחתי, מעולה ממש',
        //         starsCount: 5
        //     },
        // ])
    },
    data() {
        return {
            refreshData: 0,
            items: [
                {
                    label: 'כיתה',
                    icon: 'pi pi-th-large',
                    to: '/report',
                    admin: false,
                    grade: false
                },
                {
                    label: 'תלמיד',
                    icon: 'pi pi-user',
                    to: '/report/pupil',
                    admin: false,
                    grade: true

                },
                {
                    label: 'ניהול',
                    icon: 'pi pi-chart-bar',
                    to: '/report/menage',
                    admin: false,
                    grade: true

                },  {
                    label: 'בנק הערות',
                    icon: 'pi pi-th-large',
                    to: '/report/descriptions',
                    admin: false,
                    grade: false

                },
                {
                    label: 'הנהלה',
                    icon: 'pi pi-lock',
                    to: '/report/admin',
                    admin: true,
                    grade: true

                },
            ]
        }
    },
    computed: {
        ...mapState([ "user",'reportRanges','reportRatings']),

        itemsFiltered() {
            if (this.user?.role === 'ADMIN'){
                return this.items
            } else if (this.user?.grade) {
                return this.items.filter(item => item.admin === false);
            } else {
                return this.items.filter(item => item.grade === false);

            }
        }
    },
    methods: {
        ...mapActions(["setReportRanges", "setReportRatings"]),
        tabChange(event) {
            this.refreshData++
        }
    },


}
</script>

<style scoped>
>>> .p-menuitem-link span {
    margin-left: 7px
}
</style>